// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../college-and-career-public/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-0f0e5620]{max-width:310px;height:auto}", ""]);
// Exports
module.exports = exports;
